import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { BASE_URL, LOGIN } from '../utills/ApplicationRouting';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Controller } from 'react-hook-form';
import { TextField, Button, Typography, IconButton, InputAdornment } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setContact, setEmail, setIsContactVerified, setIsEmailVerified, setToken, setUserName } from '../redux/Qps'
import toast, { Toaster } from 'react-hot-toast';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import CommonContainer from "../components/CommonContainer";
function Login() {
  const { register, handleSubmit, formState: { errors }, getValues, setError, control, } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const onSubmit = (data) => {
    setIsLoading(true);
    const postData = {
      email: data.email,
      password: data.password,
    };

    axios
      .post(`${BASE_URL}${LOGIN}`, postData)
      .then((response) => {
        console.log(response);

        if (response.status == 200) {
          dispatch(setToken(response.data.token))
          dispatch(setUserName(response.data.name))
          dispatch(setIsContactVerified(response.data.isContactVerified))
          dispatch(setIsEmailVerified(response.data.isEmailVerified))

          dispatch(setContact(response.data.contact))
          dispatch(setEmail(response.data.email))
          console.log(response.data);
          setIsLoading(false);


          if (response.data.isEmailVerified) {

            if (!response.data.isContactVerified) {
              console.log("inside otp");

              navigate("/contactverify", { replace: true });

            }
          }
          else {
            console.log("inside email");
            navigate("/email", { replace: true });
            setIsLoading(false);


            // const postData = {
            //   email: response.data.email,
            // };
          }
          // axios
          //   .post(`${BASE_URL}${LOGINEMAILVERIFY}`, postData)
          //   .then((response) => {
          //     console.log(response);

          //     if (response.status === 200) {
          //       console.log("success");
          //       toast.success(response.data);


          //       navigate("/");
          //     }
          //   })

          // .catch((error) => {
          //   if (error.response && error.response.status !== 200) {
          //     console.log(error.response.data.message);
          //     toast.error(error.response.data.message);
          //     console.log(error.response.data.message);
          //   }
          // });
        }
        //  else if (response.data.isContactVerified) {
        //   console.log("verified");


        // }


        // localStorage.setItem("contact", response.data.contact)
        if (response.data.isEmailVerified && response.data.isContactVerified) {
          navigate("/careers", { replace: true });

          setIsLoading(false);

        }


        console.log("response", response);

      }
      )
      .catch((error) => {
        setIsLoading(false);
        toast.error(error.response.data.message);
        if (error.response && error.response.status !== 200) {
          console.log(error.response.data.message);
          setIsLoading(false);

        }
      });

  };
  return (

    <>
      <Toaster />
     <div className="w-full bg-gray-100">
  <CommonContainer>
    <div className="min-h-[80vh] flex items-center justify-center py-12">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
          <Typography variant="h6" component="span" align="center" className="block w-full font-bold mb-">
            Login
          </Typography>
          <br></br>
          <form className="mb-4" onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-4 md:w-full">
              <Controller
                name="email"
                control={control}
                defaultValue=""
                rules={{
                  required: 'Email is required',
                  pattern: {
                    value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
                    message: 'Please enter a valid email address',
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={
                      <>
                        Email <span className="text-red-500">*</span>
                      </>
                    }
                    variant="outlined"
                    fullWidth
                    error={!!errors.email}
                    helperText={errors.email?.message}
                    className="mb-4"
                  />
                )}
              />
            </div>
            <div className="mb-6 md:w-full">
              <Controller
                name="password"
                control={control}
                defaultValue=""
                rules={{
                  required: 'Password is required',
                  minLength: { value: 8, message: 'Password must be at least 8 characters long' },
                  maxLength: { value: 15, message: 'Password cannot exceed 15 characters' },
                  pattern: {
                    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+:";'.,/?><|`~=])[A-Za-z\d!@#$%^&*()_+:;'.,/?><|"`~=]{8,128}$/,
                    message: 'Password must contain at least one letter, one number, and one special character',
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={
                      <>
                        Password <span className="text-red-500">*</span>
                      </>
                    }
                    type={showPassword ? 'text' : 'password'}
                    variant="outlined"
                    fullWidth
                    error={!!errors.password}
                    helperText={errors.password?.message}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={togglePasswordVisibility} edge="end">
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </div>

            <Button
  type="submit"
  variant="contained"
  fullWidth
  sx={{
    backgroundColor: "#153E75",
    color: "#fff",
    textTransform: "uppercase",
    fontSize: "0.875rem",
    fontWeight: 600,
    py: 1,
    borderRadius: "6px",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  }}
>
  Login
</Button>
          </form>
          <Link to="/signup" className="text-blue-700 text-center text-sm block">
            Signup
          </Link>
          <Link to="/forgotPassword" className="text-blue-700 text-center text-sm block">
            Forgot password?
          </Link>
          <br>
          </br>
          <div className="text-gray-600 text-center" style={{ fontSize: '10px' }}>
            By logging into our products, you are automatically agreeing to our  Terms of Service and Privacy Policy



          </div>
        </div>
      </div>
</CommonContainer>
 </div>
    </>
  );
}

export default Login;
